// Format date
const formatDate = (dateString: string) => {
    if (!dateString) return 'Date not specified';

    try {
        const date = new Date(dateString);

        // Get parts manually
        const month = date.toLocaleString('en-US', { month: 'short' });
        const day = date.getDate();
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        // Format hours in 12-hour format
        const hour12 = hours % 12 || 12;
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const minuteStr = minutes.toString().padStart(2, '0');

        return `${month} ${day} ${year}, ${hour12}:${minuteStr} ${ampm}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'Invalid date';
    }
};

export default formatDate;


export const formatDOBDate = (dateString: string) => {
    if (!dateString) return 'Date of birth not specified';

    try {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }).format(date);
    } catch (error) {
        console.error('Error formatting date of birth:', error);
        return 'Invalid date of birth';
    }
};

export const formatMonthYear = (monthYearString?: string) => {
    if (!monthYearString) return 'N/A';

    try {
        const [year, month] = monthYearString.split('-');
        const date = new Date(parseInt(year), parseInt(month) - 1);
        return `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
    } catch (error) {
        return monthYearString;
    }
};
